import { useCallback, useMemo } from 'react';
import { transpondSliderToNum } from '../../../common/utils/calculations.util';

export const useLimitOfInvestment = ({
  volume,
  notEnoughFreeMargin,
  store,
}) => {
  const min = useMemo(() => {
    if (notEnoughFreeMargin) return 0;
    return volume.min / volume.max;
  }, [notEnoughFreeMargin, volume.min, volume.max]);

  const onChange = useCallback(
    (value) => {
      store.setLimitOfInvestment(transpondSliderToNum(value));
    },
    [store]
  );

  const value = useMemo(() => {
    return Math.max(min, store.limitOfInvestment);
  }, [min, store.limitOfInvestment]);

  return {
    min,
    onChange,
    value,
  };
};
